import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';
import { formatLocalDate } from '../utils/dateFormat';

const getTestResults = async (startDate, endDate, selectedEnvironment, selectedPackage, selectedFramework, selectedUnit, isCsqXp) => {
  try {
    const body = {
      startDate,
      endDate,
      env: selectedEnvironment.toLowerCase(),
      framework: selectedFramework.toLowerCase(),
      package: selectedPackage.toLowerCase(),
      unit: selectedUnit.toLowerCase()
    };
    if (isCsqXp !== null) {
      body.isCsqXp = isCsqXp;
    }
    const response = await api.post(`${QUALITY_SERVICE_API_URL}/hub/test-history/day-results/collapsed`, body);
    return response.data;
  } catch (error) {
    console.error('Error fetching test results:', error);
    throw error;
  }
};

const useTestResults = (selectedDate, selectedEnvironment, selectedPackage, selectedFramework, selectedUnit, isCsqXp = null, selectedStartDate = null, selectedEndDate = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const startDateKey = selectedStartDate ? formatLocalDate(selectedStartDate) : null;
  const endDateKey = selectedEndDate ? formatLocalDate(selectedEndDate) : null;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const startDate = startDateKey || formatLocalDate(selectedDate);
      const endDate = endDateKey || formatLocalDate(selectedDate);

      try {
        const result = await getTestResults(startDate, endDate, selectedEnvironment, selectedPackage, selectedFramework, selectedUnit, isCsqXp);
        const sortedResult = result.sort((a, b) => b.results.failureRate - a.results.failureRate);
        setData(sortedResult);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate, selectedEnvironment, selectedPackage, selectedFramework, selectedUnit, isCsqXp, startDateKey, endDateKey]);

  return { data, loading, error };
};

export default useTestResults; 
